import {
  FilterType,
  OfficeLocation,
  SortType,
} from "../store/actions/eventsActions";
import { useEffect, useState } from "react";

import { Event } from "../types/event";

const useHandleFilterSelections = (
  allEvents: Event[],
  eventsSortType: SortType,
  eventsFilterType?: FilterType
) => {
  const [displayedFilterSelections, setDisplayedFilterSelections] = useState<
    string[]
  >([]);
  let filters: string[] = [];

  useEffect(() => {
    if (eventsFilterType?.format.length) {
      if (
        eventsFilterType?.format !== "All" &&
        !filters.includes(eventsFilterType?.format)
      ) {
        filters.push(eventsFilterType?.format);
      }
    }
    if (eventsFilterType?.office.length) {
      if (
        eventsFilterType?.office !== OfficeLocation.NEW_ENGLAND &&
        !filters.includes(eventsFilterType?.office)
      ) {
        filters.push(eventsFilterType?.office);
      }
    }

    if (eventsFilterType?.eventTags.length) {
      if (!eventsFilterType?.eventTags.includes("All")) {
        eventsFilterType?.eventTags.forEach((tag) => {
          filters.push(tag);
        });
      }
    }
    setDisplayedFilterSelections(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventsSortType, eventsFilterType, allEvents]);

  return { displayedFilterSelections };
};

export default useHandleFilterSelections;
